<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getPayment,
  add,
  getDetails,
  update,
  del
} from "@/api/finance/payment";
import cTable from "@/base/common/index";
export default {
  name: "payment",
  components: {
    cTable
  },
  data() {
    let selectOptions = [
      { label: this.$t("wechat") + this.$t("pay"), value: "WePay" },
      { label: this.$t("alipay") + this.$t("pay"), value: "AliPay" },
      { label: this.$t("cash") + this.$t("pay"), value: "Check" },
      { label: this.$t("BankTransfer"), value: "BankTransfer" }
    ];
    return {
      methods: {
        list: getPayment,
        getDetails,
        add,
        update,
        del
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let type = "add";
              if (row.id) {
                type = "update";
              }
              this.$page.handleRequestMethods(type, row).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              payment_title: [
                {
                  required: true,
                  message: "title cannot be empty",
                  trigger: "blur"
                }
              ],
              payment_type: [
                {
                  required: true,
                  message: "type cannot be empty",
                  trigger: "blur"
                }
              ],
              payment_account: [
                {
                  required: true,
                  message: "account be empty",
                  trigger: "blur"
                }
              ],
              payment_description: [
                {
                  required: true,
                  message: "description cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { payment_title: 24 },
            { payment_type: 24 },
            { payment_account: 24 },
            { payment_description: 24 }
          ],
          fields: [
            {
              name: () => this.$t("payment_title"),
              key: "payment_title",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("payment_title")
            },
            {
              name: () => this.$t("type"),
              key: "payment_type",
              component: "Select",
              placeholder: () => this.$t("enter") + this.$t("type"),
              options: selectOptions
            },
            {
              name: () => this.$t("payment_account"),
              key: "payment_account",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("payment_account")
            },
            {
              name: () => this.$t("payment_description"),
              key: "payment_description",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("payment_description")
            }
          ]
        }
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "paymentType",
            component: "Select",
            options: selectOptions,
            bind: {
              style: {
                width: "150px"
              }
            },
            placeholder() {
              return this.$t("select") + this.$t("type");
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 135
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("payment_title"),
          key: "payment_title"
        },
        {
          name: () => this.$t("type"),
          key: "payment_type",
          methods: {
            render({ value }) {
              return selectOptions.find(item => item.value == value).label;
            }
          }
        },
        {
          name: () => this.$t("payment_account"),
          key: "payment_account"
        },
        {
          name: () => this.$t("payment_description"),
          key: "payment_description"
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 136
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 137
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
